// pages/EnquiryForm.jsx
import React, { useState } from "react";
import {
  FaUserGraduate,
  FaPhoneAlt,
  FaEnvelope,
  FaSchool,
  FaPen,
  FaCheckCircle,
  FaPaperPlane,
} from "react-icons/fa";

const EnquiryForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    className: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(formData);
    alert("Your enquiry has been submitted successfully!");
  };

  return (
    <section className="relative min-h-screen bg-gradient-to-br from-orange-50 via-white to-red-50 py-16 px-4 md:px-8 overflow-hidden">
      <div className="absolute top-0 left-0 w-72 h-72 bg-orange-300/20 rounded-full blur-3xl -translate-x-24"></div>
      <div className="absolute bottom-0 right-0 w-72 h-72 bg-red-300/20 rounded-full blur-3xl translate-x-24"></div>

      <div className="relative max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-5 py-2 text-sm font-semibold text-red-600 bg-red-100 rounded-full mb-4">
            Admission Enquiry
          </span>

          <h1 className="text-3xl md:text-5xl font-extrabold text-gray-900">
            Enquiry{" "}
            <span className="bg-gradient-to-r from-red-600 to-orange-500 bg-clip-text text-transparent">
              Form
            </span>
          </h1>

          <p className="text-gray-600 mt-4 max-w-2xl mx-auto leading-7">
            Submit your details and our admission team will contact you soon.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-[0.9fr_1.1fr] bg-white rounded-[32px] shadow-2xl overflow-hidden border border-orange-100">
          
          {/* Left Info */}
          <div className="bg-gradient-to-br from-red-600 to-orange-500 text-white p-8 md:p-10 flex flex-col justify-between">
            <div>
              <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center text-3xl mb-6">
                <FaSchool />
              </div>

              <h2 className="text-3xl md:text-4xl font-extrabold leading-tight mb-5">
                Start Your Child’s Admission Journey
              </h2>

              <p className="text-white/90 leading-8 text-sm md:text-base mb-7">
                Fill out the form with accurate details. Our school team will
                guide you with class availability, admission process and required
                documents.
              </p>

              <div className="space-y-4">
                {[
                  "Quick admission assistance",
                  "Class-wise enquiry support",
                  "Parent-friendly communication",
                  "Guidance for documents & process",
                ].map((item, index) => (
                  <div
                    key={index}
                    className="flex items-center gap-3 bg-white/15 border border-white/20 rounded-2xl p-4"
                  >
                    <FaCheckCircle className="text-yellow-200 shrink-0" />
                    <span className="text-sm font-semibold">{item}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="mt-8 bg-white/10 border border-white/20 rounded-2xl p-5">
              <p className="text-sm leading-7">
                For urgent admission queries, kindly contact the school office
                during working hours.
              </p>
            </div>
          </div>

          {/* Form */}
          <div className="p-7 md:p-10">
            <form onSubmit={handleSubmit} className="space-y-5">
              
              <div>
                <label className="block text-sm font-bold text-gray-700 mb-2">
                  Student / Parent Name
                </label>
                <div className="relative">
                  <FaUserGraduate className="absolute left-4 top-1/2 -translate-y-1/2 text-red-500" />
                  <input
                    type="text"
                    name="name"
                    required
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Enter full name"
                    className="w-full pl-12 pr-4 py-3.5 rounded-2xl border border-gray-200 bg-orange-50/40 focus:outline-none focus:ring-2 focus:ring-red-400"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-bold text-gray-700 mb-2">
                  Mobile Number
                </label>
                <div className="relative">
                  <FaPhoneAlt className="absolute left-4 top-1/2 -translate-y-1/2 text-red-500" />
                  <input
                    type="tel"
                    name="phone"
                    required
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="Enter mobile number"
                    className="w-full pl-12 pr-4 py-3.5 rounded-2xl border border-gray-200 bg-orange-50/40 focus:outline-none focus:ring-2 focus:ring-red-400"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-bold text-gray-700 mb-2">
                  Email Address
                </label>
                <div className="relative">
                  <FaEnvelope className="absolute left-4 top-1/2 -translate-y-1/2 text-red-500" />
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Enter email address"
                    className="w-full pl-12 pr-4 py-3.5 rounded-2xl border border-gray-200 bg-orange-50/40 focus:outline-none focus:ring-2 focus:ring-red-400"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-bold text-gray-700 mb-2">
                  Class Interested In
                </label>
                <select
                  name="className"
                  required
                  value={formData.className}
                  onChange={handleChange}
                  className="w-full px-4 py-3.5 rounded-2xl border border-gray-200 bg-orange-50/40 focus:outline-none focus:ring-2 focus:ring-red-400"
                >
                  <option value="">Select Class</option>
                  <option value="Play Group">Play Group</option>
                  <option value="Nursery">Nursery</option>
                  <option value="LKG">LKG</option>
                  <option value="UKG">UKG</option>
                  <option value="Class 1">Class 1</option>
                  <option value="Class 2">Class 2</option>
                  <option value="Class 3">Class 3</option>
                  <option value="Class 4">Class 4</option>
                  <option value="Class 5">Class 5</option>
                  <option value="Class 6">Class 6</option>
                  <option value="Class 7">Class 7</option>
                  <option value="Class 8">Class 8</option>
                  <option value="Class 9">Class 9</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-bold text-gray-700 mb-2">
                  Message
                </label>
                <div className="relative">
                  <FaPen className="absolute left-4 top-4 text-red-500" />
                  <textarea
                    name="message"
                    rows="4"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Write your enquiry"
                    className="w-full pl-12 pr-4 py-3.5 rounded-2xl border border-gray-200 bg-orange-50/40 focus:outline-none focus:ring-2 focus:ring-red-400 resize-none"
                  ></textarea>
                </div>
              </div>

              <button
                type="submit"
                className="w-full py-4 bg-gradient-to-r from-red-600 to-orange-500 text-white font-bold rounded-2xl shadow-lg hover:shadow-xl hover:scale-[1.02] transition-all duration-300 flex items-center justify-center gap-2"
              >
                Submit Enquiry <FaPaperPlane />
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EnquiryForm;